// Helpers to send the user back from openbankingfe to the WC host page that
// originated the OAuth flow. The return URL is established by BankConnected.js
// when the bank's OAuth callback hits /bank-connected (it persists the
// `redirectUrl` query param into sessionStorage as `obfeRedirectUrl`).

const STORAGE_KEY = 'obfeRedirectUrl';

export function getReturnUrl() {
    try {
        return sessionStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
}

export function setReturnUrl(value) {
    if (!value) return;
    try { sessionStorage.setItem(STORAGE_KEY, value); } catch {}
}

export function clearReturnUrl() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch {}
}

function clearTransientState() {
    clearReturnUrl();
    try { sessionStorage.removeItem('consentData'); } catch {}
}

// Failure path: bring the WC host back up at the start of the consent flow.
export function returnWithBcStart(route = '/aspspsList') {
    const returnUrl = getReturnUrl();
    if (!returnUrl) {
        clearTransientState();
        return false;
    }
    try {
        const url = new URL(returnUrl);
        url.searchParams.set('bcStart', route);
        clearTransientState();
        window.location.assign(url.toString());
        return true;
    } catch {
        clearTransientState();
        window.location.assign(returnUrl);
        return true;
    }
}

// Success path: invoices table should refresh itself off the ?bankConnected=1
// signal on the host page.
export function returnWithSuccess() {
    const returnUrl = getReturnUrl();
    if (!returnUrl) {
        clearReturnUrl();
        return false;
    }
    try {
        const url = new URL(returnUrl);
        url.searchParams.set('bankConnected', '1');
        clearReturnUrl();
        window.location.assign(url.toString());
        return true;
    } catch {
        clearReturnUrl();
        window.location.assign(returnUrl);
        return true;
    }
}
